import React, { createContext, useContext, useEffect, useState } from "react";
import {
  TOKEN_LOGIN_AT_KEY,
  TOKEN_STORAGE_KEY,
  clearAuthSession,
  hasActiveSession,
} from "../../helper/Constants";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(() => hasActiveSession());

  useEffect(() => {
    const syncAuthState = () => {
      setLoggedIn(hasActiveSession());
    };

    syncAuthState();

    const intervalId = window.setInterval(syncAuthState, 30000);
    const handleStorageChange = (event) => {
      if (
        !event.key ||
        event.key === TOKEN_STORAGE_KEY ||
        event.key === TOKEN_LOGIN_AT_KEY
      ) {
        syncAuthState();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const login = () => {
    setLoggedIn(hasActiveSession());
  };

  const logout = () => {
    clearAuthSession();
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ loggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
